import Vue from 'vue'
import Router from 'vue-router'
import Setup from './views/Setup.vue'
import store from '@/store.js'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/setup/:equipmentId?/:secret?',
            name: 'Setup',
            component: Setup
        },
        {
            path: '/',
            name: 'SignIn',
            component: () => import('./views/SignIn.vue')
        },
        {
            path: '/update',
            name: 'Update',
            component: () => import('./views/Update.vue')
        },
        {
            path: '/survey',
            name: 'Survey',
            component: () => import('./views/Survey.vue')
        },
        {
            path: '/satisfaction-survey',
            name: 'SatisfactionSurvey',
            component: () => import('./views/SatisfactionSurvey.vue')
        },
        {
            path: '/end',
            name: 'End',
            component: () => import('./views/End.vue')
        },
        {
            path: '/logout',
            name: 'SignOut',
            component: () => {
                store.commit('setUser', null)
                router.push('/')
            }
        },
    ]
})

export default router